// extracted by mini-css-extract-plugin
export var arrowWrapper = "styles-module--arrowWrapper--5ae15";
export var blog_description = "styles-module--blog_description--c4f2a";
export var blog_tags = "styles-module--blog_tags--74833";
export var blog_thumb_wrapper = "styles-module--blog_thumb_wrapper--4e5b0";
export var blog_title = "styles-module--blog_title--f15ec";
export var image = "styles-module--image--9a9a0";
export var product_update_wrapper = "styles-module--product_update_wrapper--30f93";
export var text = "styles-module--text--8e965";